import store from '../../store';
import router from '../../shared/router';
import logger from './logger.service';
import {InteractionRequiredAuthError, UserAgentApplication} from 'msal';
import {MSALAuthenticationProviderOptions} from '@microsoft/microsoft-graph-client/lib/es/MSALAuthenticationProviderOptions';
import {ImplicitMSALAuthenticationProvider} from '@microsoft/microsoft-graph-client/lib/es/ImplicitMSALAuthenticationProvider';
import {Client} from '@microsoft/microsoft-graph-client/lib/es/Client';

const MSAL_CONFIG = {
  auth: {
    clientId: VUE_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${VUE_APP_TENNANT_ID}`,
    validateAuthority: false,
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" to save cache in cookies to address trusted zones limitations in IE (see: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/Known-issues-on-IE-and-Edge-Browser)
  },
};

const MSAL_SCOPES = [
  'user.read',
  'openid',
  'profile',
];


const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'Directory.AccessAsUser.All',
    'Directory.Read.All',//,
    // "Directory.ReadWrite.All"
  ],
};

const b2cPolicies = {
  authorities: {
    forgotPassword: {
      authority: 'https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/b2c_1_reset',
    },
  },
};

const msalApplication = new UserAgentApplication(MSAL_CONFIG);
const msalOptions = new MSALAuthenticationProviderOptions(MSAL_SCOPES);
const msalProvider = new ImplicitMSALAuthenticationProvider(msalApplication, msalOptions);
const msgClient = Client.initWithMiddleware({
  debugLogging: true,
  authProvider: msalProvider,
});

const auth = {
  msalApplication,
  retrieveTokenInProgress: false,

  async authRedirectCallBack(error, response) {
    // Error handling
    if (error) {
      logger.error(error);

      // Check for forgot password error
      // Learn more about AAD error codes at https://docs.microsoft.com/en-us/azure/active-directory/develop/reference-aadsts-error-codes
      if (error.errorMessage.indexOf('AADB2C90118') > -1) {
        try {
          // Password reset policy/authority
          msalApplication.loginRedirect(b2cPolicies.authorities.forgotPassword);
        } catch (err) {
          logger.error(err);
        }
      }
    } else {
      // We need to reject id tokens that were not issued with the default sign-in policy.
      // To learn more about b2c tokens, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview
      if (response.tokenType === 'id_token') {
        store.dispatch('user/setAuthProgress', true);

        if (msalApplication.getAccount()) {
          const user = msalApplication.getAccount();
          store.dispatch('user/setCurrentUser', user);
          await this.retrieveAccessToken();
        }
        store.dispatch('user/setAuthProgress', false);
      } else if (response.tokenType === 'access_token') {
        this.setToken(response);
      } else {
      }
    }
  },

  async signIn() {
    msalApplication.loginRedirect(loginRequest);
    localStorage.setItem('LOGIN', 'true');
  },

  logout() {
    localStorage.clear();
    // Removes all sessions, need to call AAD endpoint to do full logout
    msalApplication.logout();
    // router.push('/auth/login');
  },
  // Acquires and access token and then passes it to the API call
  async retrieveAccessToken(redirect = true) {
    if (this.retrieveTokenInProgress) {
      return;
    }
    if (redirect) {
      await msalApplication.acquireTokenRedirect(loginRequest);
    } else {
      try {
        this.retrieveTokenInProgress = true;
        const tokenResponse = await msalApplication.acquireTokenSilent(loginRequest);
        this.retrieveTokenInProgress = false;
        this.setToken(tokenResponse, redirect);
        return tokenResponse.accessToken;
      } catch (err) {
        if (err instanceof InteractionRequiredAuthError) {
          await msalApplication.acquireTokenRedirect(loginRequest);
        } else {
          logger.error(err);
          this.retrieveTokenInProgress = false;
        }
      }
    }
  },

  async getUserAvatar() {
    return new Promise(async (resolve, reject) => {
      try {
        const blob = await msgClient.api('/me/photo/$value').get();
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
          resolve(reader.result);
        };
      } catch (e) {
        reject(e);
      }
    });
  },

  loggedIn() {
    return !!localStorage.getItem('ACCESS_TOKEN');
  },

  /**
   * @returns {string}
   */
  getToken() {
    return localStorage.getItem('ACCESS_TOKEN');
  },

  setToken(tokenResponse, redirect = true) {
    localStorage.setItem('ACCESS_TOKEN', tokenResponse.accessToken);
    localStorage.setItem('ACCESS_TOKEN_EXPIRES', tokenResponse.expiresOn.getTime());

    // if (redirect) {
    //   router.push('/')
    // }
  },

  getTokenExpireDate() {
    const time = localStorage.getItem('ACCESS_TOKEN_EXPIRES');
    return time ? parseInt(time) : 0;
  },

};

// Register Callbacks for Redirect flow
msalApplication.handleRedirectCallback(auth.authRedirectCallBack.bind(auth));

export default auth;
